import { useContext } from 'react';
import { FormGroupsContext } from './FormGroupsContext';
/**
 * Retrieve the form groups management context. Used by inputs to register themselves into a form group.
 */
export var useFormGroups = function () {
    var context = useContext(FormGroupsContext);
    return context;
};
//# sourceMappingURL=useFormGroups.js.map